import { motion } from "framer-motion";

export default function PolicyScreen({ onBack }) {
  const policies = [
    {
      title: "Contact Us",
      content: `
        <h3>Get in Touch</h3>
        <p>If you have any questions about your order or our services, please contact us:</p>
        <ul>
          <li><strong>Email:</strong> foodybuddyrestaurant@gmail.com</li>
          <li><strong>Phone:</strong> +91 9944447681</li>
          <li><strong>Address:</strong> FoodyBuddy,Canteen, Karunya Institute of Technology and Sciences, Coimbatore - 641114</li>
        </ul>
        <p>Operating Hours: 9:00 AM to 5:00 PM (Monday to Saturday)</p>
      `
    },
    {
      title: "Privacy Policy",
      content: `
        <h3>Your Privacy Matters</h3>
        <p>FoodyBuddy ("we," "us," or "our") is committed to protecting your privacy. This policy explains how we collect and use your data.</p>
        <p><strong>1. Data Collection:</strong> We collect your name, phone number, and order history to provide a personalized canteen experience.</p>
        <p><strong>2. Usage:</strong> Your data is used only for processing orders, sending OTPs for login, and improving our menu based on your preferences.</p>
        <p><strong>3. Security:</strong> We use industry-standard encryption to protect your data. We do not sell your personal information to third parties.</p>
      `
    },
    {
      title: "Terms & Conditions",
      content: `
        <h3>Standard Terms of Service</h3>
        <p>By using the FoodyBuddy app, you agree to the following terms:</p>
        <p><strong>1. Eligibility:</strong> You must be a registered student or staff member to use this service.</p>
        <p><strong>2. Ordering:</strong> All orders placed are final once the canteen begins preparation.</p>
        <p><strong>3. User Conduct:</strong> Users must provide accurate phone numbers for order tracking and communication.</p>
        <p><strong>4. Modifications:</strong> We reserve the right to modify prices or menu availability without prior notice.</p>
      `
    },
    {
      title: "Refund & Cancellation",
      content: `
        <h3>Refund Policy</h3>
        <p><strong>1. Cancellation:</strong> You can cancel your order and receive a full refund only if the order status is "New" and has not been accepted by the canteen.</p>
        <p><strong>2. Refunds:</strong> If an order is cancelled by the Admin (due to unavailability of items), a full refund will be initiated automatically to your original payment method within 5-7 business days.</p>
        <p><strong>3. No-Refund Cases:</strong> No refunds will be provided for orders already marked as "Preparing" or "Ready for Pickup".</p>
      `
    }
  ];

  return (
    <motion.div
      className="screen"
      initial={{ opacity: 0, x: "100%" }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: "100%" }}
      transition={{ type: "spring", damping: 25, stiffness: 200 }}
      style={{ background: "#FAFAF8", zIndex: 2000 }}
    >
      <div className="screen-header" style={{ position: "sticky", top: 0, background: "#FAFAF8", zIndex: 10 }}>
        <button className="back-btn" onClick={onBack}>‹</button>
        <div className="screen-title">Policies & Support</div>
      </div>

      <div className="screen-body" style={{ padding: "1rem 1.5rem 100px" }}>
        {policies.map((p, i) => (
          <section key={i} style={{ marginBottom: "2.5rem", animation: `fadeUp 0.5s ease ${i * 0.1}s both` }}>
            <h2 style={{
              fontFamily: "'Sora', sans-serif",
              fontSize: "1.25rem",
              color: "var(--primary)",
              borderBottom: "1.5px solid #eee",
              paddingBottom: "8px",
              marginBottom: "1rem"
            }}>
              {p.title}
            </h2>
            <div
              style={{ fontSize: "14px", color: "#555", lineHeight: "1.6" }}
              dangerouslySetInnerHTML={{ __html: p.content }}
            />
          </section>
        ))}

        <div style={{ textAlign: "center", padding: "20px 0", color: "#AAA", fontSize: "12px" }}>
          © 2026 FoodyBuddy Services · All Rights Reserved
        </div>
      </div>

      <style jsx>{`
        h3 { font-size: 15px; margin: 15px 0 8px 0; color: #333; }
        p { margin-bottom: 12px; }
        ul { margin-bottom: 12px; padding-left: 20px; }
        li { margin-bottom: 6px; }
      `}</style>
    </motion.div>
  );
}
